import clsx from 'clsx';
import { t } from '@lingui/core/macro';
import { THEME_COLORS, type ThemeColor } from '../../types/theme';

interface ColorPickerProps {
  currentColor: ThemeColor;
  onColorChange: (color: ThemeColor) => void;
  className?: string;
  /** ARIA role for each color button (e.g. "menuitem" when used inside a menu) */
  itemRole?: string;
}

function ColorPicker({
  currentColor,
  onColorChange,
  className,
  itemRole,
}: ColorPickerProps) {
  return (
    <div className={clsx('flex justify-between gap-1', className)}>
      {THEME_COLORS.map((themeColor) => (
        <button
          key={themeColor}
          onClick={() => onColorChange(themeColor)}
          className={clsx(
            'duration-normal h-6 flex-1 rounded border transition-colors',
            currentColor === themeColor ? 'border-2' : 'border',
          )}
          style={{
            backgroundColor:
              themeColor === 'light'
                ? 'var(--white-100)'
                : themeColor === 'sepia'
                  ? 'var(--sepia-100)'
                  : themeColor === 'storm'
                    ? 'var(--neutral-800)'
                    : 'var(--neutral-900)',
            borderColor: currentColor === themeColor ? '#0074bf' : 'var(--border-strong)',
          }}
          role={itemRole}
          aria-label={t`${themeColor} theme`}
        />
      ))}
    </div>
  );
}

export default ColorPicker;
